import React, { useState } from "react";
import Iamarks from "../components/IaMarks/Iamarks";
import Aside from "../modules/SideNav/Aside";

const IamarksLayout = () => {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };
  return (
    <div className={`app ${rtl ? "rtl" : ""} ${toggled ? "toggled" : ""}`}>
      <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      />
      <Iamarks />
    </div>
  );
};

export default IamarksLayout;
